<template>
  <div>
    <div class="py-3"></div>
    <v-card class="mx-auto" max-width="95%">
      <v-toolbar color="teal darken-2" dark>
        <v-icon left>mdi-gift-outline</v-icon>
        <v-toolbar-title>보상형 하우스애드 관리</v-toolbar-title>
        <v-spacer />
        <v-btn color="lime" small fab @click="OnClick_Create">
          <v-icon color="teal darken-2">mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="adList"
        :loading="loadingData"
        :footer-props="{'items-per-page-options':[20,50,-1]}"
      >
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.id }}</td>
            <td>{{ row.item.ad_key }}</td>
            <td>{{ row.item.title }}</td>
            <td class="text-right">{{ formatNum(row.item.impression_count) }}</td>
            <td class="text-right">{{ formatNum(row.item.reward_count) }}</td>
            <td class="text-right">{{ formatNum(row.item.click_count) }}</td>
            <td>
              <v-switch v-model="row.item._active" inset hide-details dense @change="OnToggleActive(row.item)"></v-switch>
            </td>
            <td style="white-space: nowrap;">
              <v-btn class="mx-1" fab dark x-small color="deep-purple" @click="OnClick_Stats(row.item)">
                <v-icon dark small>mdi-chart-bar</v-icon>
              </v-btn>
              <v-btn class="mx-1" fab dark x-small color="blue darken-1" @click="OnClick_Edit(row.item)">
                <v-icon dark small>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn class="mx-1" fab dark x-small color="red darken-1" @click="OnClick_Delete(row.item)">
                <v-icon dark small>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- 등록/수정 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="900" persistent scrollable>
      <v-card>
        <v-card-title class="text-h6 teal--text text--darken-2">
          {{ editing.id ? '보상형 하우스애드 수정' : '보상형 하우스애드 등록' }}
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 72vh;">
          <div class="py-2"></div>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editing.ad_key" label="ad_key (자동 생성·고유·수정불가)" outlined dense readonly filled hint="자동 발급되는 고유 키입니다. 앱은 placement 로 광고를 조회합니다." persistent-hint prepend-inner-icon="mdi-key-variant"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editing.title" label="제목 (CMS 표시용)" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field v-model.number="editing.duration_sec" type="number" label="진행시간(초)" outlined dense hint="이 시간이 지나면 보상 버튼이 활성화됩니다" persistent-hint></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model="editing.reward_button_text" label="보상 버튼 문구" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field v-model.number="editing.priority" type="number" label="우선순위" outlined dense hint="여러 광고가 켜져 있으면 높은 것이 노출됩니다" persistent-hint></v-text-field>
            </v-col>
            <v-col cols="6" sm="4">
              <v-switch v-model="editing.allow_early_close" inset label="조기 종료 허용" hide-details dense></v-switch>
            </v-col>
            <v-col cols="6" sm="4">
              <v-switch v-model="editing.is_active" inset label="노출 ON" hide-details dense></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editing.start_at" label="게재 시작 (옵션)" type="datetime-local" outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editing.end_at" label="게재 종료 (옵션)" type="datetime-local" outlined dense></v-text-field>
            </v-col>
          </v-row>
          <v-text-field v-model="editing.memo" label="관리 메모 (옵션)" outlined dense></v-text-field>

          <!-- 블록 편집 -->
          <div class="d-flex align-center mt-2 mb-2">
            <strong class="text-subtitle-1">본문 블록</strong>
            <v-spacer />
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="teal" dark small v-bind="attrs" v-on="on"><v-icon left small>mdi-plus</v-icon>블록 추가</v-btn>
              </template>
              <v-list dense>
                <v-list-item v-for="opt in blockTypeOptions" :key="opt.value" @click="addBlock(opt.value)">
                  <v-list-item-icon class="mr-2"><v-icon>{{ opt.icon }}</v-icon></v-list-item-icon>
                  <v-list-item-title>{{ opt.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-alert v-if="!editing.blocks.length" type="info" dense outlined>블록을 추가하세요. (배너 / 텍스트 / 유튜브 / 이미지 / 링크버튼)</v-alert>

          <v-card v-for="(b, idx) in editing.blocks" :key="idx" outlined class="mb-3">
            <v-toolbar dense flat color="grey lighten-4">
              <v-chip small dark :color="blockColor(b.block_type)" class="mr-2">{{ blockLabel(b.block_type) }}</v-chip>
              <span class="text-caption">#{{ idx + 1 }}</span>
              <v-spacer />
              <v-btn icon small :disabled="idx === 0" @click="moveBlock(idx, -1)"><v-icon small>mdi-arrow-up</v-icon></v-btn>
              <v-btn icon small :disabled="idx === editing.blocks.length - 1" @click="moveBlock(idx, 1)"><v-icon small>mdi-arrow-down</v-icon></v-btn>
              <v-btn icon small color="red" @click="removeBlock(idx)"><v-icon small>mdi-delete</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <template v-if="b.block_type === 'text'">
                <v-textarea v-model="b.text_content" label="텍스트" outlined dense rows="2" auto-grow hide-details></v-textarea>
              </template>
              <template v-else-if="b.block_type === 'banner' || b.block_type === 'image'">
                <v-alert dense text type="info" color="teal darken-1" class="text-caption mb-2 py-2">
                  <div v-for="(line, li) in sizeGuides[b.block_type]" :key="li" class="d-flex align-start">
                    <v-icon x-small color="teal darken-1" class="mr-1 mt-1">mdi-image-size-select-large</v-icon><span>{{ line }}</span>
                  </div>
                </v-alert>
                <div v-if="b.image_url" class="mb-2">
                  <img :src="b.image_url" style="max-width: 100%; max-height: 180px; border: 1px solid #eee;" />
                </div>
                <v-file-input label="이미지 업로드" outlined dense hide-details accept="image/*" :loading="b._uploading" @change="onImageSelect(b, $event)"></v-file-input>
                <v-text-field v-model="b.image_url" label="이미지 URL" outlined dense class="mt-2"></v-text-field>
                <v-text-field v-model="b.link_url" label="클릭 이동 링크 (옵션)" outlined dense></v-text-field>
                <v-text-field v-model="b.alt_text" label="alt 텍스트 (옵션)" outlined dense hide-details></v-text-field>
              </template>
              <template v-else-if="b.block_type === 'youtube'">
                <v-alert dense text type="info" color="red darken-1" class="text-caption mb-2 py-2">
                  <div v-for="(line, li) in sizeGuides.youtube" :key="li" class="d-flex align-start">
                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-crop</v-icon><span>{{ line }}</span>
                  </div>
                </v-alert>
                <v-text-field v-model="b.youtube_video_id" label="유튜브 링크 또는 영상 ID" outlined dense hint="링크 붙여넣으면 영상 ID 자동 추출 (예: https://youtu.be/aqz-KE-bpKQ → aqz-KE-bpKQ)" persistent-hint @change="normalizeYoutube(b)" @blur="normalizeYoutube(b)"></v-text-field>
                <v-text-field v-model="b.link_url" label="클릭 이동 링크 (옵션)" outlined dense class="mt-2" hide-details></v-text-field>
              </template>
              <template v-else-if="b.block_type === 'link_button'">
                <v-text-field v-model="b.text_content" label="버튼 문구" outlined dense></v-text-field>
                <v-text-field v-model="b.link_url" label="이동 URL (필수)" outlined dense hide-details></v-text-field>
              </template>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">취소</v-btn>
          <v-btn color="teal darken-1" dark :loading="saving" @click="OnSave">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 통계 다이얼로그 -->
    <v-dialog v-model="statsDialog" max-width="820" scrollable>
      <v-card>
        <v-card-title class="text-h6 deep-purple--text">
          통계 — {{ statsTarget.title || statsTarget.ad_key }}
          <v-spacer />
          <v-btn icon @click="statsDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row class="mt-1">
            <v-col cols="4"><v-card flat color="#E8EAF6" class="pa-3 text-center"><div class="text-caption">노출</div><div class="text-h6">{{ formatNum(statsData.totals.impression) }}</div></v-card></v-col>
            <v-col cols="4"><v-card flat color="#E8F5E9" class="pa-3 text-center"><div class="text-caption">보상</div><div class="text-h6">{{ formatNum(statsData.totals.reward) }}</div></v-card></v-col>
            <v-col cols="4"><v-card flat color="#FFF3E0" class="pa-3 text-center"><div class="text-caption">링크 클릭</div><div class="text-h6">{{ formatNum(statsData.totals.link_click) }}</div></v-card></v-col>
          </v-row>
          <div class="text-subtitle-2 mt-4 mb-1">일별 추이 (최근 30일)</div>
          <div class="chart-container" style="height: 240px;">
            <line-chart v-if="statsChartData" :chart-data="statsChartData" :options="trendChartOptions" />
            <div v-else class="d-flex justify-center align-center" style="height:100%; color:#999;">데이터 없음</div>
          </div>
          <div class="text-subtitle-2 mt-4 mb-1">링크별 클릭 (링크관리)</div>
          <v-simple-table dense>
            <template v-slot:default>
              <thead><tr><th>블록</th><th>타입</th><th>링크</th><th class="text-right">클릭수</th></tr></thead>
              <tbody>
                <tr v-for="l in statsData.links" :key="l.block_id">
                  <td>#{{ l.block_id }}</td>
                  <td>{{ blockLabel(l.block_type) }}</td>
                  <td style="max-width:340px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">{{ l.link_url || l.text_content || '' }}</td>
                  <td class="text-right">{{ formatNum(l.click_count) }}</td>
                </tr>
                <tr v-if="!statsData.links.length"><td colspan="4" class="text-center grey--text">링크 블록이 없습니다.</td></tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import LineChart from '../billing/charts/LineChart';
const { FileUpload_Async } = require('../../util/fileutil');

const S3_PREFIX = 'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/';

const blankEditing = () => ({
    id: 0, ad_key: '', title: '', layout_type: 'video', duration_sec: 15,
    reward_button_text: '리워드 지급됨', allow_early_close: false, is_active: true,
    placement: '', priority: 0, start_at: '', end_at: '', memo: '', blocks: [],
});

export default {
    name: 'RewardAdManage',
    components: { LineChart },

    data: () => ({
        loadingData: false,
        saving: false,
        dialog: false,
        statsDialog: false,
        adList: [],
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'ad_key', value: 'ad_key' },
            { text: '제목', value: 'title' },
            { text: '노출', value: 'impression_count', align: 'end' },
            { text: '보상', value: 'reward_count', align: 'end' },
            { text: '클릭', value: 'click_count', align: 'end' },
            { text: '노출ON', value: '_active', sortable: false },
            { text: '관리', value: 'action', sortable: false },
        ],
        blockTypeOptions: [
            { text: '배너', value: 'banner', icon: 'mdi-image-area' },
            { text: '텍스트', value: 'text', icon: 'mdi-format-text' },
            { text: '유튜브', value: 'youtube', icon: 'mdi-youtube' },
            { text: '이미지', value: 'image', icon: 'mdi-image' },
            { text: '링크버튼', value: 'link_button', icon: 'mdi-link-variant' },
        ],
        // 블록 타입별 권장 소스 사이즈 안내 (모달 콘텐츠폭 ~448px 기준, 레티나용 ~1.6x)
        sizeGuides: {
            banner: [
                '가로형(상단 띠): 720 × 240 px (3:1) · JPG/WebP, 150KB 이하',
                '세로형(싱글): 720 × 900 px (4:5) · JPG/WebP, 250KB 이하',
            ],
            image: [
                '권장 800 × 1000 px (4:5) 또는 800 × 800 (1:1) · 풀세로는 720 × 1280 (9:16) · 300~400KB 이하',
            ],
            youtube: [
                '권장 1280 × 720 (16:9) · ⚠️ 자막·로고 등 핵심은 중앙 약 70% 세이프존 안에 배치 (상하좌우 ~17% crop)',
            ],
        },
        editing: blankEditing(),
        statsTarget: {},
        statsData: { totals: { impression: 0, reward: 0, link_click: 0 }, links: [], daily: [] },
        trendChartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: true },
            tooltips: { mode: 'index', intersect: false },
            scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }] },
        },
    }),

    created() {
        this.loadList();
    },

    methods: {
        ...mapActions([
            'GET_REWARD_AD_LIST', 'GET_REWARD_AD_DETAIL', 'SAVE_REWARD_AD',
            'DELETE_REWARD_AD', 'SET_REWARD_AD_ACTIVE', 'GET_REWARD_AD_STATS',
        ]),
        formatNum(v) { const n = Number(v); return isNaN(n) ? '0' : n.toLocaleString(); },
        blockLabel(t) { const o = this.blockTypeOptions.find((x) => x.value === t); return o ? o.text : t; },
        blockColor(t) { return { banner: 'indigo', text: 'blue-grey', youtube: 'red', image: 'teal', link_button: 'deep-orange' }[t] || 'grey'; },
        // 유튜브: 링크를 붙여넣으면 11자리 영상 ID 만 추출 (watch?v= / youtu.be / embed / shorts 지원)
        extractYoutubeId(input) {
            if (!input) return input;
            const s = String(input).trim();
            if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s; // 이미 ID
            const m = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|[?&]v=)([A-Za-z0-9_-]{11})/);
            return m ? m[1] : s;
        },
        normalizeYoutube(b) { b.youtube_video_id = this.extractYoutubeId(b.youtube_video_id); },
        toLocalInput(dt) { return dt ? moment(dt).format('YYYY-MM-DDTHH:mm') : ''; },
        toMysqlDt(v) { return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : null; },

        loadList() {
            this.loadingData = true;
            this.GET_REWARD_AD_LIST().then((body) => {
                this.loadingData = false;
                const rows = (body && body.result) || [];
                rows.forEach((r) => { r._active = Number(r.is_active) === 1; });
                this.adList = rows;
            }).catch((err) => {
                this.loadingData = false;
                console.error(err);
                alert('목록 로드 실패: ' + err);
            });
        },

        genAdKey() {
            // 사람 개입 없이 겹치지 않는 고유 키 (읽기전용). 앱은 placement 로 조회.
            return 'rad_' + Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
        },

        OnClick_Create() {
            this.editing = blankEditing();
            this.editing.ad_key = this.genAdKey();
            this.dialog = true;
        },

        OnClick_Edit(item) {
            this.GET_REWARD_AD_DETAIL({ id: item.id }).then((body) => {
                const res = (body && body.result) || {};
                const ad = res.ad || {};
                const blocks = (res.blocks || []).map((b) => ({
                    block_type: b.block_type,
                    sort_order: b.sort_order,
                    text_content: b.text_content || '',
                    image_url: b.image_url || '',
                    link_url: b.link_url || '',
                    youtube_video_id: b.youtube_video_id || '',
                    alt_text: b.alt_text || '',
                    _uploading: false,
                }));
                this.editing = {
                    id: ad.id,
                    ad_key: ad.ad_key || '',
                    title: ad.title || '',
                    layout_type: ad.layout_type || 'video',
                    duration_sec: Number(ad.duration_sec != null ? ad.duration_sec : 15),
                    reward_button_text: ad.reward_button_text || '리워드 지급됨',
                    allow_early_close: Number(ad.allow_early_close) === 1,
                    is_active: Number(ad.is_active) === 1,
                    placement: ad.placement || '',
                    priority: Number(ad.priority != null ? ad.priority : 0),
                    start_at: this.toLocalInput(ad.start_at),
                    end_at: this.toLocalInput(ad.end_at),
                    memo: ad.memo || '',
                    blocks,
                };
                this.dialog = true;
            }).catch((err) => {
                console.error(err);
                alert('상세 로드 실패: ' + err);
            });
        },

        addBlock(type) {
            this.editing.blocks.push({
                block_type: type, sort_order: this.editing.blocks.length,
                text_content: '', image_url: '', link_url: '', youtube_video_id: '', alt_text: '', _uploading: false,
            });
        },
        removeBlock(idx) { this.editing.blocks.splice(idx, 1); },
        moveBlock(idx, dir) {
            const t = idx + dir;
            if (t < 0 || t >= this.editing.blocks.length) return;
            const arr = this.editing.blocks;
            const tmp = arr[idx];
            this.$set(arr, idx, arr[t]);
            this.$set(arr, t, tmp);
        },

        async onImageSelect(block, file) {
            if (!file) return;
            block._uploading = true;
            try {
                const ext = (file.name.split('.').pop() || 'jpg').toLowerCase();
                const rand = Math.random().toString(36).substring(2, 12);
                const key = `snapquiz/housead_img/${rand}.${ext}`;
                const ok = await FileUpload_Async(file, key);
                if (ok) { block.image_url = S3_PREFIX + key; }
                else { alert('이미지 업로드 실패'); }
            } catch (e) {
                console.error(e);
                alert('이미지 업로드 오류: ' + e);
            }
            block._uploading = false;
        },

        OnSave() {
            if (!this.editing.ad_key || !this.editing.ad_key.trim()) { alert('ad_key 를 입력하세요.'); return; }
            const blocks = this.editing.blocks.map((b, i) => ({
                sort_order: i,
                block_type: b.block_type,
                text_content: b.text_content || null,
                image_url: b.image_url || null,
                link_url: b.link_url || null,
                youtube_video_id: b.youtube_video_id || null,
                alt_text: b.alt_text || null,
            }));
            const payload = {
                id: this.editing.id || 0,
                ad_key: this.editing.ad_key.trim(),
                title: this.editing.title,
                layout_type: this.editing.layout_type,
                duration_sec: Number(this.editing.duration_sec) || 15,
                reward_button_text: this.editing.reward_button_text,
                allow_early_close: this.editing.allow_early_close ? 1 : 0,
                is_active: this.editing.is_active ? 1 : 0,
                placement: this.editing.placement || null,
                priority: Number(this.editing.priority) || 0,
                start_at: this.toMysqlDt(this.editing.start_at),
                end_at: this.toMysqlDt(this.editing.end_at),
                memo: this.editing.memo || null,
                blocks,
            };
            this.saving = true;
            this.SAVE_REWARD_AD(payload).then(() => {
                this.saving = false;
                this.dialog = false;
                alert('저장되었습니다.');
                this.loadList();
            }).catch((err) => {
                this.saving = false;
                console.error(err);
                alert('저장 실패: ' + err);
            });
        },

        OnToggleActive(item) {
            this.SET_REWARD_AD_ACTIVE({ id: item.id, is_active: item._active ? 1 : 0 }).then(() => {
                item.is_active = item._active ? 1 : 0;
            }).catch((err) => {
                console.error(err);
                alert('상태 변경 실패: ' + err);
                item._active = !item._active;
            });
        },

        OnClick_Delete(item) {
            if (!confirm(`[${item.ad_key}] 광고를 삭제할까요? 블록도 함께 삭제됩니다.`)) return;
            this.DELETE_REWARD_AD({ id: item.id }).then(() => {
                alert('삭제되었습니다.');
                this.loadList();
            }).catch((err) => {
                console.error(err);
                alert('삭제 실패: ' + err);
            });
        },

        OnClick_Stats(item) {
            this.statsTarget = item;
            this.statsData = { totals: { impression: 0, reward: 0, link_click: 0 }, links: [], daily: [] };
            this.statsDialog = true;
            this.GET_REWARD_AD_STATS({ id: item.id }).then((body) => {
                const res = (body && body.result) || {};
                this.statsData = {
                    totals: Object.assign({ impression: 0, reward: 0, link_click: 0 }, res.totals || {}),
                    links: res.links || [],
                    daily: res.daily || [],
                };
            }).catch((err) => {
                console.error(err);
                alert('통계 로드 실패: ' + err);
            });
        },
    },

    computed: {
        statsChartData() {
            const rows = this.statsData.daily || [];
            if (!rows.length) return null;
            const mapImp = {}; const mapRew = {}; const mapClk = {};
            rows.forEach((r) => {
                const d = String(r.dt || r.DT || '').substring(0, 10);
                if (!d) return;
                mapImp[d] = Number(r.impression || 0);
                mapRew[d] = Number(r.reward || 0);
                mapClk[d] = Number(r.link_click || 0);
            });
            const labels = []; const imp = []; const rew = []; const clk = [];
            for (let i = 29; i >= 0; i--) {
                const d = moment().subtract(i, 'days').format('YYYY-MM-DD');
                labels.push(d);
                imp.push(mapImp[d] || 0);
                rew.push(mapRew[d] || 0);
                clk.push(mapClk[d] || 0);
            }
            return {
                labels,
                datasets: [
                    { label: '노출', backgroundColor: 'rgba(63,81,181,0.15)', borderColor: '#3F51B5', data: imp, fill: true },
                    { label: '보상', backgroundColor: 'rgba(76,175,80,0.15)', borderColor: '#4CAF50', data: rew, fill: true },
                    { label: '링크클릭', backgroundColor: 'rgba(255,152,0,0.15)', borderColor: '#FF9800', data: clk, fill: true },
                ],
            };
        },
    },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
}
.chart-container > div {
  position: relative;
  height: 100%;
}
</style>
